<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="标题：" prop="Title">
          <el-input
            placeholder="请输入标题"
            v-model="dataForm.Title"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="Contacts">
          <el-input
            placeholder="请输入联系人"
            v-model="dataForm.Contacts"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="Phone">
          <el-input
            placeholder="请输入联系电话"
            v-model="dataForm.Phone"
            clearable
            maxlength="13"
          ></el-input>
        </el-form-item>
        <el-form-item label="讲座类型：" prop="LectureType">
          <el-select v-model="dataForm.LectureType" placeholder="请选择">
            <el-option
              v-for="item in LectureTypeOption"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="讲座地点"
          prop="Address"
          v-if="this.dataForm.LectureType === 0"
        >
          <el-input
            placeholder="请输入讲座地点"
            v-model="dataForm.Address"
            clearable
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="讲座时间"
          prop="StartTime"
          v-if="this.dataForm.LectureType === 0"
        >
          <el-date-picker
            v-model="dataForm.StartTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="报名须知：" prop="Condition">
          <el-input
            placeholder="请输入报名须知"
            v-model="dataForm.Condition"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="学员名额："
          prop="StuPlaces"
          v-if="this.dataForm.LectureType === 0"
        >
          <el-input-number
            v-model="dataForm.StuPlaces"
            :min="1"
            :max="10000"
            label="请输入人数"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="收费费用(元)："
          prop="GroupCost"
          v-if="this.dataForm.LectureType === 1"
        >
          <el-input
            placeholder="请输入收费费用"
            v-model="dataForm.GroupCost"
            clearable
            maxlength="100"
            style="width: 28%"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面图：" prop="HeadImge">
          <p>支持png/jpg/jpeg格式，建议尺寸650*360</p>
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            @onRemove="onRemove"
            @onUpLoad="onUpLoad"
            :limit="1"
            :fileList="pictureList"
            :class="{ hide: hideUploadEdit }"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <div slot="content">
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="讲座介绍：" prop="Abstract">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Abstract"
            :height="500"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    //金额校验
    var checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("费用不能为空且保留两位小数"));
      }
      if (
        !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
          value
        )
      ) {
        return callback(new Error("无效捐款金额，请保留两位小数"));
      }
      callback();
    };
    //手机号码验证规则
    var checkMobileNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      }
      if (
        !/^1[0-9]{10}$/.test(value) &&
        !/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/.test(value)
      ) {
        return callback(new Error("无效手机号码"));
      }
      callback();
    };
    return {
      //表单规则
      editFormRules: {
        Title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        Contacts: [
          { required: true, message: "联系人不能为空", trigger: "blur" },
        ],
        Phone: [
          { required: true, validator: checkMobileNo, trigger: "blur" },
        ],
        PersonalCost: [
          { required: true, validator: checkAmount, trigger: "blur" },
        ],
        GroupCost: [
          { required: true, validator: checkAmount, trigger: "blur" },
        ],
        // MinimumCost: [
        //   { required: true, validator: checkAmount, trigger: "blur" }
        // ],
        StuPlaces: [
          { required: true, message: "学员名额不能为空", trigger: "change" },
        ],
        HeadImge: [
          { required: true, message: "封面图不能为空", trigger: "blur" },
        ],
        Abstract: [
          { required: true, message: "讲座介绍不能为空", trigger: "blur" },
        ],
        Address: [
          { required: true, message: "讲座地点不能为空", trigger: "blur" },
        ],
        LectureType: [
          { required: true, message: "请选择讲座类型", trigger: "change" },
        ],
        Condition: [
          { required: true, message: "报名须知", trigger: "blur" },
        ],
        StartTime: {
          required: true,
          message: "请选择时间",
          trigger: "blur",
        },
      },
      isConfirm: false,
      pictureList: [],
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      hideUploadEdit: false,
      hideUploadFileEdit: false,
      width: "60%",
      LectureTypeOption: [
        { id: 0, text: "公益" },
        { id: 1, text: "收费" },
      ],//讲座类型
      dataForm: {},
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    OfDialog,
    OfUpload,
    OfTinymce,
  },
  methods: {
    //初始化数据
    loadData() {
      if (this.id) {
        let params = { id: this.id };
        api.QueryTrainById(params).then((res) => {
          if (res.data.Code === 0) {
            this.dataForm = res.data.Data;
            this.dataForm.StartTime = this.dataForm.StartTime * 1000;
            this.getImg();
            this.getFile();
          }
        });
      }
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //保存&更新
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.DeadLine = 0;
          params.EndTime = 0;
          params.Status = 0;
          params.Type = 2;
          if (params.StartTime) {
            params.StartTime = params.StartTime / 1000;
          }else{
            params.StartTime = 0;
          }
          api
            .SaveTrain(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //删除封面图
    onRemove() {
      this.pictureList = [];
      this.dataForm.HeadImge = null;
      this.hideUploadEdit = false;
    },
    //查看图片
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传封面图
    onUpLoad(file) {
      if (file.response.Code === 0) {
        this.dataForm.HeadImge = file.response.Data.FileId;
        this.$message({
          message: "封面图上传成功",
          type: "success",
        });
        this.hideUploadEdit = true;
      }
    },
    //初始化封面图
    getImg() {
      if (
        this.dataForm.HeadImge === undefined ||
        this.dataForm.HeadImge === null ||
        this.dataForm.HeadImge == ""
      ) {
        return;
      }
      this.hideUploadEdit = true;
      this.$http
        .get("/Sys/File/Download?Id=" + this.dataForm.HeadImge)
        .then((res) => {
          let pictureList = [res.config];
          this.pictureList = pictureList.map((item) => {
            return {
              url: item.url,
            };
          });
        });
    },
    //上传附件
    onFileUpLoad(file) {
      if (file.response.Code === 0) {
        const list = { name: file.name, url: file.response.Data.FileId };
        this.fileList.push(list);
        this.dataForm.File = JSON.stringify(this.fileList);
        this.hideUploadFileEdit = true;
        this.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //附件校验
    onCheckFile(file, status) {
      let size = file.size / 1024 / 1024;
      if (size > 100) {
        this.$message({
          type: "error",
          message: "附件大小必须小于100M",
        });
        status(false);
        return;
      }
    },
    //删除附件
    onFileRemove() {
      this.fileList = [];
      this.dataForm.File = null;
      this.hideUploadFileEdit = false;
    },
    //点击下载
    onFilePreview(file) {
      saveAs("/Sys/File/Download?Id=" + file.url, file.name);
    },
    //初始化附件
    getFile() {
      if (
        this.dataForm.File === undefined ||
        this.dataForm.File === null ||
        this.dataForm.File == ""
      ) {
        return;
      }
      this.fileList = JSON.parse(this.dataForm.File);
      this.hideUploadFileEdit = true;
    },
  },
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
</style>

<style>
.hide {
  display: block !important;
}

.hideFile .el-upload--fileList {
  display: none;
}
</style>
